import { useContext } from "react";

import { LLMConfigContext } from "../../contexts/user/LLMConfigContext";

const useLLMConfig = () => {
  const context = useContext(LLMConfigContext);
  return context;
};

export default useLLMConfig;
